















import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import ExpertHeader from "@/components/ExpertHeader/ExpertHeader.vue";
import { MutationsTypes } from "../store/modules/delayCodes/mutations";

@Component({
  components: {
    ExpertHeader
  }
})
export default class GuidedMode extends Vue {
  get shouldRedirectToBreakdown(): boolean {
    if (
      store.state.delayCodes.expertModeCode.length === 3 &&
      !store.state.delayCodes.expertModeCodeIsInvalid
    ) {
      store.commit.delayCodes[MutationsTypes.EXPERT_SET_CODE]("");
      this.$router.push("breakdown");
      return true;
    } else {
      return false;
    }
  }

  get isError(): boolean {
    return store.state.delayCodes.expertModeCodeIsInvalid;
  }

  get enteredCode(): string {
    return store.state.delayCodes.expertModeCode.toUpperCase();
  }
}
